import { Record } from '../../../../models/record';
import { CitationStyle } from '../../../services/dialogs/citation/citation.model';

export class OpenCitationModal {
  static type = '[Citation] Open Citation Modal';

  constructor(public record: Record) {}
}

export class CloseCitationModal {
  static type = '[Citation] Close Citation Modal';
}

export class GetCitationStyles {
  static type = '[Citation] Get Citation Styles';

  constructor(public recordId: string) {}
}

export class SetSelectedCitationStyle {
  static type = '[Citation] Set Selected Citation Style';

  constructor(public style: CitationStyle) {}
}
